import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ToggleableIconProps } from "../../../../types/IconProps";
import { getIconColor } from "../../../../services/iconService";

const IconParentalLeave = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m195.41,113.06c-.6-.01-1.2-.02-1.79-.02-49.13,0-89.58,39.48-90.55,88.82-.47,24.2,8.5,47.14,25.27,64.58s39.33,27.31,63.53,27.78c.6.01,1.2.02,1.8.02,49.15,0,89.61-39.49,90.57-88.84.98-49.94-38.87-91.37-88.83-92.34Zm-1.75,172.69c-.54,0-1.09,0-1.63-.02-21.92-.43-42.37-9.37-57.56-25.17-15.2-15.81-23.33-36.59-22.9-58.52.87-44.71,37.52-80.48,82.05-80.48.54,0,1.09,0,1.63.02,45.27.88,81.38,38.42,80.49,83.68-.88,44.73-37.53,80.51-82.07,80.51Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m252.38,239.63c-2.41-1.76-5.78-1.22-7.54,1.19-1.75,2.41-1.22,5.78,1.19,7.53.96.7,2.07,1.03,3.17,1.03,1.67,0,3.31-.77,4.37-2.22,1.75-2.41,1.22-5.78-1.19-7.53Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m245.94,158.83c-2.41,1.76-2.93,5.13-1.17,7.54,1.05,1.44,2.69,2.21,4.36,2.21,1.1,0,2.21-.34,3.17-1.04,2.41-1.76,2.94-5.13,1.18-7.54-1.76-2.4-5.14-2.93-7.54-1.17Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m134.96,239.69c-2.41,1.75-2.94,5.13-1.18,7.53,1.05,1.45,2.7,2.22,4.36,2.22,1.1,0,2.21-.34,3.17-1.04,2.41-1.75,2.94-5.12,1.18-7.53-1.75-2.41-5.12-2.94-7.53-1.18Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m262.31,209.04c2.97,0,5.39-2.41,5.39-5.4v-.15c0-2.98-2.43-5.39-5.41-5.38-2.97,0-5.38,2.42-5.38,5.4v.13c0,2.99,2.42,5.4,5.4,5.4Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m172.33,143.76c.56,0,1.12-.09,1.68-.27,2.83-.92,4.38-3.97,3.45-6.8-.92-2.83-3.97-4.38-6.8-3.45-2.83.92-4.38,3.96-3.45,6.8.74,2.27,2.85,3.72,5.12,3.72Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m174.13,263.84c-2.83-.92-5.87.64-6.79,3.47s.63,5.87,3.47,6.79c.55.18,1.11.27,1.66.27,2.27,0,4.39-1.45,5.13-3.74.92-2.83-.63-5.87-3.47-6.79Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m213.11,143.43c.55.18,1.11.26,1.65.26,2.28,0,4.4-1.45,5.13-3.73.92-2.84-.64-5.88-3.47-6.8-2.83-.91-5.87.64-6.79,3.48-.92,2.83.64,5.88,3.48,6.79Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m124.99,198.32c-2.98,0-5.39,2.42-5.39,5.4.01,2.98,2.42,5.39,5.4,5.39s5.39-2.42,5.39-5.4c0-2.98-2.42-5.39-5.4-5.39Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m134.88,167.73c.96.69,2.07,1.02,3.17,1.02,1.67,0,3.31-.77,4.37-2.22,1.74-2.41,1.21-5.79-1.2-7.53-2.41-1.75-5.78-1.22-7.53,1.19s-1.22,5.78,1.19,7.54Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m213.23,263.82c-2.83.92-4.38,3.97-3.46,6.8.74,2.28,2.85,3.72,5.13,3.72.55,0,1.11-.08,1.66-.26,2.84-.92,4.39-3.96,3.47-6.8-.93-2.83-3.97-4.38-6.8-3.46Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m236.47,199.5l-31.4-.97c-.59-1.3-1.39-2.51-2.41-3.57-1.02-1.05-2.2-1.89-3.48-2.52l-.14-44.26c0-2.97-2.42-5.38-5.39-5.38h-.02c-2.98,0-5.39,2.43-5.38,5.41l.14,44.07c-1.25.58-2.41,1.35-3.43,2.34-2.41,2.31-3.77,5.43-3.83,8.77-.13,6.91,5.37,12.65,12.26,12.78.08,0,.17,0,.25,0,4.85,0,9.08-2.79,11.16-6.87l31.33.97c.06,0,.11,0,.17,0,2.9,0,5.3-2.31,5.39-5.23.09-2.98-2.25-5.47-5.22-5.56Zm-38.89,4.98c-.4,1.85-2.07,3.22-4.02,3.2-2.21-.04-3.97-1.89-3.92-4.11.02-1.07.46-2.07,1.23-2.81.6-.58,1.35-.94,2.16-1.06.26.04.51.08.77.08h.02c.19,0,.37-.04.55-.06.83.15,1.58.54,2.18,1.16.57.59.93,1.33,1.07,2.12-.04.23-.07.47-.07.71,0,.27,0,.53.04.79Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m115.54,272.31c-5.6,5.6-13.04,8.68-20.95,8.68h-36.22c-7.91,0-15.35-3.08-20.95-8.68-7.76-7.76-12.04-18.09-12.04-29.07v-93.11c0-11.36,4.77-22.32,13.08-30.07l7.9-7.36h60.25l7.89,7.36c2.07,1.93,3.94,4.07,5.56,6.38,1.05,1.49,2.72,2.29,4.41,2.29,1.07,0,2.16-.32,3.1-.99,2.43-1.72,3.02-5.08,1.3-7.52-1.93-2.73-4.14-5.28-6.56-7.59,8.74-.78,15.62-8.13,15.62-17.08v-11.02c0-9.46-7.7-17.15-17.15-17.15h-2.39c-2.47-3.16-7.52-7.95-17.21-11.59-4.04-1.52-7.57-5.03-9.2-9.15-.91-2.29-1.61-5.79.2-9.47,2.97-6.03,3.29-17.16-1.35-24.62-3.18-5.12-8.29-7.93-14.36-7.93s-11.18,2.82-14.36,7.93c-4.65,7.46-4.32,18.59-1.35,24.62,1.77,3.61,1.98,7.42.57,10.74-1.52,3.59-4.83,6.35-9.31,7.79-10.08,3.23-15.19,8.27-17.64,11.68h-2.64c-9.46,0-17.15,7.7-17.15,17.15v11.02c0,9.08,7.09,16.51,16.03,17.1-10.19,9.75-16.03,23.37-16.03,37.49v93.11c0,13.86,5.4,26.89,15.2,36.69,7.63,7.63,17.78,11.84,28.58,11.84h36.22c10.79,0,20.94-4.2,28.58-11.84,2.11-2.11,2.11-5.52,0-7.63-2.11-2.11-5.52-2.11-7.63,0ZM55.32,65.97c7.51-2.41,13.18-7.32,15.95-13.84,2.66-6.25,2.37-13.26-.82-19.72-1.4-2.85-1.79-9.95.83-14.16,1.23-1.97,2.83-2.85,5.2-2.85s3.98.88,5.2,2.85c2.62,4.21,2.23,11.31.83,14.16-2.77,5.63-2.97,12.1-.55,18.2,2.76,6.97,8.53,12.68,15.43,15.28,1.29.48,2.45.99,3.51,1.5h-49.29c1.11-.49,2.33-.97,3.7-1.41Zm-29.93,29.58v-11.02c0-3.51,2.86-6.37,6.37-6.37h89.04c3.51,0,6.37,2.86,6.37,6.37v11.02c0,3.51-2.86,6.37-6.37,6.37h-11.46c-.41-.05-.83-.04-1.24,0h-63.22c-.41-.04-.82-.05-1.24,0h-11.89c-3.51,0-6.37-2.86-6.37-6.37Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m46.6,162.84c0-15.4,3.62-21.52,5.95-23.87,1.18-1.19,1.71-2.87,1.47-4.53-.65-4.36-6.01-6.11-9.1-2.97-4.45,4.51-9.06,13.46-9.11,31.13,0,2.83,2.07,5.36,4.89,5.61,3.21.29,5.9-2.22,5.9-5.37Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m61.81,178.05h-20.6c-2.98,0-5.39,2.42-5.39,5.39s2.42,5.39,5.39,5.39h20.6c2.98,0,5.39-2.42,5.39-5.39s-2.42-5.39-5.39-5.39Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m61.81,198.65h-20.6c-2.98,0-5.39,2.42-5.39,5.39s2.42,5.39,5.39,5.39h20.6c2.98,0,5.39-2.42,5.39-5.39s-2.42-5.39-5.39-5.39Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m61.81,219.25h-20.6c-2.98,0-5.39,2.42-5.39,5.39s2.42,5.39,5.39,5.39h20.6c2.98,0,5.39-2.42,5.39-5.39s-2.42-5.39-5.39-5.39Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m61.81,239.85h-20.6c-2.98,0-5.39,2.42-5.39,5.39s2.42,5.39,5.39,5.39h20.6c2.98,0,5.39-2.42,5.39-5.39s-2.42-5.39-5.39-5.39Z"
      />
    </SvgIcon>
  );
};

export default IconParentalLeave;
